import Spinner from '../../../atoms/Spinner';
import { useDelayRender } from '../../../../hooks/useDelayRender';
import React from 'react';
import { style } from './pdfNotification.linaria';
function PDFNotification({ text }) {
    const { shouldRender } = useDelayRender();
    if (!shouldRender) {
        return null;
    }
    return (<div className={`${style} pdf-notification`}>{text || <Spinner />}</div>);
}
PDFNotification.defaultProps = {
    text: undefined,
};
export default PDFNotification;
